import Vue from 'vue'
import fieldGroupPropsMixin from './field-group-props-mixin'
import FieldGroup from './field-group'

import withRender from './textarea.html'
import './textarea.scss'

export const DEFAULT_MAX_CHARACTERS = 500

export default withRender((Vue as any).extend({
  // data() {
  //   return {
  //     hasFocus: false
  //   }
  // },
  props: {
    describedbyId: {
      type: String,
      default: () => `tt-hint-${Math.random().toString(16).slice(5)}`
    },
    disabled: Boolean,
    focusOnMount: Boolean, // The field should have focus if true.
    id: {
      type: String,
      default: () => `tt-textarea-${Math.random().toString(16).slice(5)}`
    },
    characterThreshold: { // character count to be shown if charactersLeft > characterThreshold
      type: Number,
      default: DEFAULT_MAX_CHARACTERS
    },
    maxCharacters: {
      type: Number,
      default: DEFAULT_MAX_CHARACTERS
    },
    name: {
      type: String,
      required: true
    },
    rows: String,
    success: Boolean,
    value: {
      type: String,
      default: ''
    }
  },
  mixins: [fieldGroupPropsMixin],
  components: { 'tt-field-group': FieldGroup },
  computed: {
    charactersLeft() {
      return this.maxCharacters - this.value.length
    },
    error() {
      let error = this.charactersLeft < 0 ?
        this.$msg('cc.charactersOver', [Math.abs(this.charactersLeft)]) : ''
      if (this.errorText) {
        // tslint:disable-next-line:max-line-length
        error += (this.charactersLeft < 0 ? ' <span class="tt-o-hint__dot">' + this.$msg('hint.error.separator') + '</span> ' : '') + this.errorText
      }
      return error
    },
    hint() {
      return this.charactersLeft >= 0
        && this.charactersLeft <= this.characterThreshold ?
        this.$msg('cc.charactersLeft', [this.charactersLeft]) : this.hintText
    }
  },
  methods: {
    blurTextarea(e) {
      this.$emit('blurTextArea', e.target)
    },
    // Input event fired when the user clicks into the field.
    focusTextarea(e) {
      this.$emit('focusTextArea', e.target)
    },
    // Event fired when the input changes in the textarea
    updateValue(e) {
      this.$emit('input', e.target.value)
    }
  },
  mounted() {
    if (this.focusOnMount) {
      // delay so that the modal doesn't take the focus back on it's mount.
      // This will fire the focus event, causing focusTextarea to be called.
      setTimeout(() => this.$refs.field.focus(), 100)
    }
  }
}))
